/**
 * 3桁カンマ
 *
 * @export
 * @param {string|number} value
 * @returns
 */
export function addComma(value) {
  if (Number.isNaN(value - 0)) {
    return value;
  }
  var str = value + ""; // {string}
  while (str !== (str = str.replace(/^(-?\d+)(\d{3})/, "$1,$2"))); // 3桁毎にカンマを挿入
  return str;
}

/**
 *
 *
 * @export
 * @param {string} identifier
 * @returns
 */
export function getIdentifierName(identifier) {
  if (typeof identifier !== "string") {
    return identifier;
  }
  let identifierName;
  switch (identifier) {
    case "grade":
      identifierName = "バージョン";
      break;
    case "color":
      identifierName = "カラー";
      break;
    case "roof":
      identifierName = "エキゾースト";
      break;
    case "gtsExteriorRoof":
      identifierName = "ルーフ";
      break;
    case "gtsExteriorAero":
      identifierName = "エアロキット";
      break;
    case "gtsExteriorExhaust":
      identifierName = "エキゾースト";
      break;
    case "tire":
      identifierName = "タイヤ";
      break;
    case "wheel":
      identifierName = "ホイール";
      break;
    case "caliper":
      identifierName = "キャリパー";
      break;
    case "interior":
      identifierName = "内装";
      break;
    case "handle":
      identifierName = "ハンドル";
      break;
    default:
      identifierName = "";
  }
  return identifierName;
}

/**
 *
 * 文字を小文字に変換
 * @export
 * @param {string} value
 * @returns
 */
export function toLowerCase(value) {
  if (typeof value !== "string") {
    return value;
  }
  return value.toLowerCase();
}
